//import * as Products from './Products.js';

export const ruleBagSize = (item)=>{
	if( !window.__config_reactjs_cart.products_config || !window.__config_reactjs_cart.products_config.hasOwnProperty(item.product_id) ) return {original: item.original_line_price,final:item.final_line_price};
	let product_config = window.__config_reactjs_cart.products_config[item.product_id];
	//console.log(product_config);

	let saved = 0;
  let price = "";
	if( typeof product_config["discounts"] !== "undefined" ){
    let tmp = item["options_with_values"][2]["value"];
    //console.log(tmp);
    if( typeof product_config["discounts"][tmp] !== "undefined"){
      let index = getBagSizeQuantityTierIndex(product_config["discounts"][tmp]["tables"],item["quantity"]);
      price = product_config["discounts"][tmp]["tables"]["Price/lb"][index];
      if( product_config["discounts"][tmp]["rates"][index]>0 ){
        saved = product_config["discounts"][tmp]["rates"][index]/100*(item["price"]/100)*item["quantity"];
        saved *= 100;
        //saved = saved.toFixed(2);
      }
    }
  }
  //console.log(saved);
  //console.log(item.final_line_price);
  //console.log(item.final_line_price-saved);
  
  //Extra fee
  let extra_fee = 0;
  if( typeof product_config["extra_fee"] !== "undefined" ){
    for( let key in product_config["extra_fee"] ){
    	let fee = product_config["extra_fee"][key];
    	let option_of_color = item["options_with_values"][0]["value"];
    	if( fee["type"]==="special_variant" && fee["variant_option"].includes(option_of_color) ){
    		extra_fee += (fee["fee"]*100);
      }
    }
  }

	return {original: item.original_line_price,final:(item.final_line_price-saved+extra_fee),saved:saved,price:price};
}

const getBagSizeQuantityTierIndex = (tables,quantity)=>{
  let index = 0;
  for( let key in tables ){
  	let data_array = tables[key];
    for( let i in data_array ){
    	let tier_quantity = data_array[i];
      if( quantity>=tier_quantity ) index = i;
    }
    break;
  }
  return index;
}